<template>
  <div style="height: 100%">
    <wxapp-list v-if="shownPage == 0" @changeView = "changeView"></wxapp-list>
    <code-authorize v-else-if="shownPage == 1" @changeView = "changeView" :channelSetParam="channelSet" :strategies="strategies"></code-authorize>
    <key-access v-else-if="shownPage == 2" @changeView = "changeView" :channelSetParam="channelSet" :strategies="strategies"></key-access>
  </div>
</template>
<script>
import WxappList from './wxappList'
import CodeAuthorize from './codeAuthorize'
import KeyAccess from './keyAccess/index'

export default {
  name: '',
  data() {
    return {
      shownPage: 0,
      channelSet: {},
      strategies: []
    }
  },
  components: {
    WxappList,
    CodeAuthorize,
    KeyAccess
  },
  mounted() {
    this.getStrategies()
  },
  methods: {
    changeView(shownPage, channelSet) {
      this.shownPage = shownPage
      this.channelSet = channelSet
    },

    getStrategies() {
      var that = this
      const params = {
        platformId: 'miniprogram'
      }

      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/getStrategies', { params }).then(res => {
        if (res.data.code === 2000) {
          that.strategies = res.data.data

          if (this.$route.query.auth_code) {
            this.shownPage = 1
          }
        }
      })
    }
  }
}
</script>
